import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Field } from "redux-form/immutable";
import { Grid, MenuItem } from "@material-ui/core";

import TextField from "app/components/form/TextField";
import { fieldStatusToString } from "features/planner/planner.mappers";
import { getCountriesFromState } from "features/planner/planner.selectors";
import { FIELD_STATUS, FIELD_FORM } from "features/planner/planner.constants";
import ReadOnlyWarning from "features/planner/settings/components/ReadOnlyWarning";

const renderTextField = props => (
  <Field fullWidth margin="normal" component={TextField} {...props} />
);

const FieldForm = ({ handleSubmit, countries, sourceUri }) => {
  if (sourceUri) {
    return (
      <ReadOnlyWarning>
        This field is read-only and cannot be edited
      </ReadOnlyWarning>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={12}>
          {renderTextField({
            label: "Name",
            required: true,
            autoFocus: true,
            name: FIELD_FORM.NAME,
          })}
        </Grid>
        <Grid item xs={12}>
          {renderTextField({
            label: "Operator",
            name: FIELD_FORM.OPERATOR,
          })}
        </Grid>
        <Grid item xs={12}>
          {renderTextField({
            select: true,
            label: "Status",
            name: FIELD_FORM.STATUS,
            children: Object.values(FIELD_STATUS).map(fieldStatus => (
              <MenuItem key={fieldStatus} value={fieldStatus}>
                {fieldStatusToString(fieldStatus)}
              </MenuItem>
            )),
          })}
        </Grid>
        <Grid item xs={12}>
          {renderTextField({
            select: true,
            required: true,
            label: "Country",
            name: FIELD_FORM.COUNTRY,
            children: countries.map(country => (
              <MenuItem key={country.get("id")} value={country.get("id")}>
                {country.get("name")}
              </MenuItem>
            )),
          })}
        </Grid>
      </Grid>
    </form>
  );
};

export default compose(
  connect((state, { formValueSelector }) => ({
    countries: getCountriesFromState(state),
    sourceUri: formValueSelector(state, FIELD_FORM.SOURCE_URI),
  })),
)(FieldForm);
